import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { CityService } from '../../services/city.service';
import { ContactService } from '../../services/contact.service';
import { CSEService } from '../../services/cse.service';
import { UtilService } from '../../services/util.service';
import {
    Carrier
    , CarrierScoreCard
    , CarrierService
    , CarrierServiceMap
    , Contact
    , SearchCarrier
    , SearchCityState
} from '../../models/models';

@Component({
    selector: 'carrier-detail',
    templateUrl: './carrier-detail.component.html',
    standalone: false
})
export class CarrierDetail implements OnInit {
    public carrierCode: string = '';
    public carrierName: string = '';
    public carrier: Carrier = {} as Carrier;
    public searchCarrier: SearchCarrier = {} as SearchCarrier;
    public carrierScoreCard: CarrierScoreCard = {} as CarrierScoreCard;
    public contacts: Contact[] = [];
    public tagsRefreshDate: Date = new Date();
    public carrierServiceList: CarrierService[] = [];
    public carrierServiceIDList: number[] = [];
    public opportunityID: number = 0;
    public searchCityState: SearchCityState = {} as SearchCityState;

    public showEquipment: boolean = false;
    public showCustomerExclusion: boolean = false;
    public showIncidents: boolean = false;
    public showLanes: boolean = false;
    public showRFQ: boolean = false;
    public showAnalysis: boolean = false;

    constructor(private route: ActivatedRoute, private titleService: Title, private router: Router,
        private cityService: CityService, private contactService: ContactService, private cseService: CSEService,
        private utilService: UtilService, public datePipe: DatePipe) {
        route.params.subscribe(params => { this.carrierCode = params.carrierCode });
        route.params.subscribe(params => { this.opportunityID = params.opportunityID });
        titleService.setTitle('Carrier Profile - ' + this.carrierCode);
    }

    ngOnInit() {
        this.getCarrierServices();
        this.searchCarrierByCarrierCode();
    }

    private searchCarrierByCarrierCode() {
        if (this.carrierCode == null || this.carrierCode.length < 1) return;

        this.cseService.searchCarrier(this.carrierCode).subscribe(result => {
            if (result == null) return;

            this.carrier = result;
            this.getSearchCityState();
            this.getSearchCarrier();
            this.getCarrierScoreCard();
            this.getContacts();
            this.getCarrierServiceMaps();
        });
    }

    private getSearchCarrier() {
        this.utilService.isLoading = true;
        this.cseService.getSearchCarrierByCarrierID(this.carrier.carrierID).subscribe(result => {
            this.utilService.isLoading = false;
            this.searchCarrier = result.resultCollection[0];
        });
    }

    private getSearchCityState() {
        this.cityService.getSearchCityStateByCityID(this.carrier.cityID).subscribe(result => {
            this.searchCityState = result.resultCollection[0];
        });
    }

    private getCarrierServices() {
        this.cseService.getAllCarrierServices().subscribe(result => {
            this.carrierServiceList = result;
        });
    }

    private getCarrierScoreCard() {
        this.cseService.getCarrierScoreCard(this.carrier.carrierID).subscribe(result => {
            if (result.resultCollection.length > 0) {
                this.carrierScoreCard = result.resultCollection[0];
            }
            else {
                this.carrierScoreCard = {} as CarrierScoreCard;
            }
        });
    }

    public getScoreCardClass(statType: string) {
        if (statType == "onTimePercentage") {
            if (this.carrierScoreCard.onTimePercentage > 90) {
                return "text-success";
            }
            else if (this.carrierScoreCard.onTimePercentage > 80) {
                return "text-primary";
            }
            else if (this.carrierScoreCard.onTimePercentage > 70) {
                return "text-info";
            }
            else if (this.carrierScoreCard.onTimePercentage > 60) {
                return "text-warning";
            }
            else {
                return "text-danger";
            }
        }
        else if (statType == "loadsOnMacropointPercentage") {
            if (this.carrierScoreCard.loadsOnMacropointPercentage > 90) {
                return "text-success";
            }
            else if (this.carrierScoreCard.loadsOnMacropointPercentage > 80) {
                return "text-primary";
            }
            else if (this.carrierScoreCard.loadsOnMacropointPercentage > 70) {
                return "text-info";
            }
            else if (this.carrierScoreCard.loadsOnMacropointPercentage > 60) {
                return "text-warning";
            }
            else {
                return "text-danger";
            }
        }
        else if (statType == "verifiedOnTime") {
            if (this.carrierScoreCard.verifiedOnTime > 90) {
                return "text-success";
            }
            else if (this.carrierScoreCard.verifiedOnTime > 80) {
                return "text-primary";
            }
            else if (this.carrierScoreCard.verifiedOnTime > 70) {
                return "text-info";
            }
            else if (this.carrierScoreCard.verifiedOnTime > 60) {
                return "text-warning";
            }
            else {
                return "text-danger";
            }
        }
        else if (statType == "incidentReports") {
            if (this.carrierScoreCard.incidentReports < 5) {
                return "text-success";
            }
            else if (this.carrierScoreCard.incidentReports < 10) {
                return "text-primary";
            }
            else if (this.carrierScoreCard.incidentReports < 15) {
                return "text-info";
            }
            else if (this.carrierScoreCard.incidentReports < 20) {
                return "text-warning";
            }
            else {
                return "text-danger";
            }
        }
        else if (statType == "loadsRanLast30Days") {
            if (this.carrierScoreCard.loadsRanLast30Days > 20) {
                return "text-success";
            }
            else if (this.carrierScoreCard.loadsRanLast30Days > 15) {
                return "text-primary";
            }
            else if (this.carrierScoreCard.loadsRanLast30Days > 10) {
                return "text-info";
            }
            else if (this.carrierScoreCard.loadsRanLast30Days > 5) {
                return "text-warning";
            }
            else {
                return "text-danger";
            }
        }
        else if (statType == "last30DaysNetRevenue") {
            if (this.carrierScoreCard.last30DaysNetRevenue > 1000) {
                return "text-success";
            }
            else if (this.carrierScoreCard.last30DaysNetRevenue > 500) {
                return "text-primary";
            }
            else if (this.carrierScoreCard.last30DaysNetRevenue > 100) {
                return "text-info";
            }
            else if (this.carrierScoreCard.last30DaysNetRevenue > 50) {
                return "text-warning";
            }
            else {
                return "text-danger";
            }
        }
    }

    private getCarrierServiceMaps() {
        this.cseService.getServiceMapsByCarrierId(this.carrier.carrierID).subscribe(result => {
            if (result == null) return;

            result.forEach(s => {
                this.carrierServiceIDList.push(s.carrierServiceID);
                var service = this.carrierServiceList.find(t => t.carrierServiceID == s.carrierServiceID);
                if (service != null) {
                    service.isChecked = true;
                }
            });
        });
    }

    public setCarrierServiceMap(service: CarrierService) {
        service.isChecked = !service.isChecked;
        this.saveCarrierServiceMaps(service);
    }

    public saveCarrierServiceMaps(service: CarrierService) {
        var idx = this.carrierServiceIDList.indexOf(service.carrierServiceID);
        if (!service.isChecked && idx >= 0) {
            this.carrierServiceIDList.splice(idx, 1);
        }
        else if (idx < 0) {
            this.carrierServiceIDList.push(service.carrierServiceID);
        }

        console.log("saveCarrierServiceMaps", idx, this.carrierServiceIDList, service);

        let maps: CarrierServiceMap[] = [];

        if (this.carrierServiceIDList.length > 0) {
            var employeeID = parseInt(localStorage.getItem('EmployeeId')!);
            this.carrierServiceIDList.forEach(s => {
                var map = {
                    carrierID: this.carrier.carrierID,
                    carrierServiceID: s,
                    carrierServiceMapID: 0,
                    createdDate: new Date(),
                    employeeID: employeeID
                } as CarrierServiceMap;

                maps.push(map);
            });

            this.utilService.isLoading = true;
            this.cseService.saveCarrierServiceMaps(maps).subscribe(result => {
                this.utilService.isLoading = false;
                var ok = result;
            });
        } else {
            this.utilService.isLoading = true;
            this.cseService.deleteCarrierServiceMapsByCarrierId(this.carrier.carrierID).subscribe(result => {
                this.utilService.isLoading = false;
                var ok = result;
            });
        }
    }

    private getContacts() {
        this.contactService.getSearchContactByCarrierID(this.carrier.carrierID).subscribe(result => {
            this.contacts = result.resultCollection;
        });
    }

    public onTabSelect(evt: any) {
        console.log("onTabSelect", evt);
    }

    public panelExpandedChange(panelName: string, $event) {
        if (panelName == 'EquipmentServices') {
            this.showEquipment = $event;
        }
        else if (panelName == 'CustomerExclusionIncidents') {
            this.showCustomerExclusion = $event;
            this.showIncidents = $event;
        }
        else if (panelName == 'Lanes') {
            this.showLanes = $event;
        }
        else if (panelName == 'RFQAnalysis') {
            this.showRFQ = $event;
            this.showAnalysis = $event;
        }
        console.log("panelExpandedChange", panelName, $event);
    }

    public carrierSaved(evt: any) {
        this.searchCarrierByCarrierCode();
    }

    public refreshData(evt: any) {
        if (evt == "tags") {
            this.tagsRefreshDate = new Date();
        }
    }
}
